<template>
  <div class="DoorColor">
    <ATable
      ref="table"
      :data="items"
      :disable_insert="!has_grant_write"
      hide-top-panel
      hide-pagination
      border
      @cell-click="handleCellClick"
      @clicked-create="handleClickedCreate"
    >
      <el-table-column
        type="index"
        label="No"
        align="center"
        prop="index"
        :width="$width.index"
        :index="handleIndex"
      />
      <el-table-column label="색상" prop="name">
        <template slot-scope="scope">
          <el-input
            size="mini"
            :readonly="scope.row.id !== editingId"
            v-bind:class="{ 'readonly-noborder': scope.row.id !== editingId }"
            v-model="scope.row.name"
          />
        </template>
      </el-table-column>
      <el-table-column label="명령" width="150">
        <template slot-scope="scope">
          <div v-show="scope.row.id === editingId">
            <el-button
              type="primary"
              size="mini"
              :disabled="!has_grant_write"
              :loading="load_button"
              @click="handleClickRegister(scope.row)"
              >저장</el-button
            >
            <el-button size="mini" @click="calcelEditing(scope.row)"
              >취소</el-button
            >
          </div>
          <div v-show="scope.row.id !== editingId">
            <el-button
              type="danger"
              size="mini"
              :disabled="!has_grant_write"
              :loading="load_button"
              @click="handleClickDelete(scope.row)"
              >삭제</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
    </ATable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { base_data } from "@/common/mixins/base_data";

export default {
  name: "DoorColor",
  mixins: [base_data],
  data() {
    return {
      title: this.$t("title.door_color"),
      items: [],
      editingId: -1,
      oldItem: undefined,
      deleteData: undefined,
      base_data: ["table_door_color"],
      load_button: false,
    };
  },
  props: {
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_door_color"]),
  },
  mounted() {
    this.init();
  },
  destroyed() {
    if (this.editingId < 0) {
      return;
    }
    this.calcelEditing(this.oldItem);
    this.editingId = -1;
  },
  methods: {
    init() {
      this.items = JSON.parse(JSON.stringify(this.table_door_color));
    },
    calcelEditing(data) {
      let index = this.items.findIndex((i) => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    doDelete() {
      this.load_button = true;
      this.api.deleteDoorColor(this.deleteData).then((res) => {
        this.load_button = false;
        this.handleResult(res, this.$t("message.success_delete"));
      });
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickedCreate() {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.editingId = 0;
      this.oldItem = { id: 0, name: "" };
      this.items.push(this.oldItem);
    },
    handleCellClick(item, column) {
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) {
        return;
      }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickRegister(data) {
      let isDuplicated = false;
      if (data.name.trim() === "") {
        this.util.notify_warning(this, this.title, "색상을 입력해주세요.");
        return;
      }
      this.items.forEach((item) => {
        if (item.id !== data.id && item.name === data.name) {
          isDuplicated = true;
        }
      });
      if (isDuplicated) {
        this.util.notify_warning(this, this.title, "중복된 색상입니다.");
        return;
      }
      this.load_button = true;
      if (data.id) {
        this.api.updateDoorColor(data).then((res) => {
          this.load_button = false;
          this.handleResult(res, this.$t("message.success_update"));
        });
      } else {
        this.api.createDoorColor(data).then((res) => {
          this.load_button = false;
          this.handleResult(res, this.$t("message.success_create"));
        });
      }
    },
    handleClickDelete(data) {
      this.deleteData = data;
      this.util.confirm_delete(
        this,
        this.title + "[" + data.name + "]",
        this.doDelete
      );
    },
    handleResult(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.editingId = -1;
      this.util.notify_success(this, this.title, successMessage);
    },
  },
};
</script>
